// Validações iguais às do banco (migrations 0100 e 0200). O banco continua
// sendo a palavra final; aqui é só para avisar antes de enviar.

export const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA',
  'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

export function apenasDigitos(texto) {
  return String(texto ?? '').replace(/\D/g, '');
}

// CPF/CNPJ: só letras e números, em maiúsculas (o CNPJ novo tem letras).
export function normalizarDocumento(texto) {
  return String(texto ?? '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

export function cpfValido(texto) {
  const d = apenasDigitos(texto);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const dv = (base) => {
    let soma = 0;
    for (let i = 0; i < base; i++) soma += Number(d[i]) * (base + 1 - i);
    const r = (soma * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return dv(9) === Number(d[9]) && dv(10) === Number(d[10]);
}

// CNPJ numérico e alfanumérico: 12 posições [0-9A-Z] + 2 dígitos verificadores.
// Valor de cada caractere = código ASCII − 48.
export function cnpjValido(texto) {
  const c = normalizarDocumento(texto);
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(c) || /^(.)\1{13}$/.test(c)) return false;
  const dv = (tamanho) => {
    const pesos = tamanho === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < tamanho; i++) soma += (c.charCodeAt(i) - 48) * pesos[i];
    const r = soma % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return dv(12) === Number(c[12]) && dv(13) === Number(c[13]);
}

// 'PF' (CPF), 'PJ' (CNPJ) ou null, pelo tamanho do que foi digitado.
export function tipoDoDocumento(texto) {
  const c = normalizarDocumento(texto);
  if (/^[0-9]{11}$/.test(c)) return 'PF';
  if (c.length === 14) return 'PJ';
  return null;
}

export function documentoValido(texto, tipo = tipoDoDocumento(texto)) {
  const c = normalizarDocumento(texto);
  if (tipo === 'PF') return /^[0-9]{11}$/.test(c) && cpfValido(c);
  if (tipo === 'PJ') return cnpjValido(c);
  return false;
}

// Celular sempre como 55 + DDD + número. Devolve null se não der para entender.
export function normalizarCelular(texto) {
  let d = apenasDigitos(texto);
  if (d.length === 12 || d.length === 13) {
    if (!d.startsWith('55')) return null;
    d = d.slice(2);
  }
  if (d.length !== 10 && d.length !== 11) return null;
  if (d.startsWith('0')) return null;
  return `55${d}`;
}

// Placa antiga (ABC1234) ou Mercosul (ABC1D23).
export function normalizarPlaca(texto) {
  return String(texto ?? '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

export function placaValida(texto) {
  return /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(normalizarPlaca(texto));
}

export function renavamValido(texto) {
  const d = apenasDigitos(texto);
  return d.length >= 9 && d.length <= 11;
}

export function ufValida(uf) {
  return UFS.includes(String(uf ?? '').toUpperCase());
}

export function emailValido(texto) {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(texto ?? '').trim());
}
